import { PanelResizeHandle } from "react-resizable-panels";
import styles from "../applications/appstyles/styles.module.css"

export function AppResizeHandle({   className = "",   id })
{
 
  return (
    <PanelResizeHandle
      className={[styles.ResizeHandleOuter, className].join(" ")}
      id={id}
    >
      <div className={styles.ResizeHandleInner}>
      </div>
    </PanelResizeHandle>
  );
}

// ******************************************************************************************************************
// assets utils
// ******************************************************************************************************************

export function appAsset_getCorrectedFromOriginal(assets, original)
{
    for (var i=0; i<assets.length; i++)
        if (assets[i].asoriid === original) return assets[i];
    return null;
}


export function appAsset_getFirstAssetByType(assets, type)
{
    for (var i=0; i<assets.length; i++)
        if (assets[i].astype === type) return assets[i];
    return null;
}

export function appAsset_getAssetById(assets, id)
{
    for (var i=0; i<assets.length; i++)
        if (assets[i].asid === id) return assets[i];
    return null;
}




export function appAsset_getCurrentDate () 
 {
  const today = new Date();

  const year = today.getFullYear(); // Année AAAA
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
  const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)

  return `${year}/${month}/${day}`;
};

export function appAsset_generateUUID() 
{
const array = new Uint8Array(16);
window.crypto.getRandomValues(array);

array[6] = (array[6] & 0x0f) | 0x40; // Version 4
array[8] = (array[8] & 0x3f) | 0x80; // Variant 1

return [...array].map((byte, index) => {
    const hex = byte.toString(16).padStart(2, '0');
    return ([4, 6, 8, 10].includes(index) ? '-' : '') + hex;
}).join('');
}
